import { type UserProfile } from '../api/schema/profileSchema';
import { isNewUser } from '../profileParser';
import { isAppUser, isExtensionUser } from '../appLinks';
import { createPaymentSubmit } from './newPaymentSubmit';

import { affilateStore as store } from '@/store/affiliate';
import { showErrorNotification } from '@/store/new-order/notificationsSlice';
import { startSubmitting, stopSubmitting } from '@/store/new-order/submitSlice';
import {
  switchToSuccessStep,
  switchToSuccessStepForAppUser,
  switchToSuccessStepWithDownload,
  switchToSuccessForExtensionUser,
} from '@/store/affiliate/stepsSlice';

const data = {
  getSelectedPlan: () => store.getState().plans.selectedPlan,
  getUserProfile: () => store.getState().user.profile,
  getCouponCode: () => store.getState().coupon.code,
};

const actions = {
  onStartSubmit: () => store.dispatch(startSubmitting()),
  onStopSubmit: () => store.dispatch(stopSubmitting()),
  onSuccess: (profile: UserProfile) => {
    if (isExtensionUser()) {
      store.dispatch(switchToSuccessForExtensionUser());
    } else if (isNewUser(profile)) {
      store.dispatch(switchToSuccessStepWithDownload());
    } else if (isAppUser()) {
      store.dispatch(switchToSuccessStepForAppUser());
    } else {
      store.dispatch(switchToSuccessStep());
    }
  },
  showError: (text: string) => store.dispatch(showErrorNotification(text)),
};

const paymentSubmit = createPaymentSubmit(data, actions);

export const { stripePromise, onPaymentRequestSubmit, onCardFormSubmit, onExpressCheckoutConfirm } = paymentSubmit;
